import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function HakkimizdaPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const values = [
    {
      icon: 'ri-shield-star-line',
      title: 'Kalite',
      description: 'En kaliteli ürünleri müşterilerimize sunmak için titizlikle çalışıyoruz.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Müşteri Memnuniyeti',
      description: 'Müşteri memnuniyeti bizim için her şeyden önce gelir.'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Yenilikçilik',
      description: 'Sektördeki yenilikleri takip eder ve müşterilerimize sunarız.'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Güvenilirlik',
      description: '30 yıllık tecrübemizle güvenilir hizmet sunuyoruz.'
    }
  ];

  const timeline = [
    {
      year: '1995',
      title: 'Kuruluş',
      description: 'Üçoklar Perde, Ankara\'da perde sektöründe hizmet vermeye başladı.'
    },
    {
      year: '2005',
      title: 'Büyüme',
      description: 'Halı satışı ve ev tekstili ürünlerini ürün yelpazemize ekledik.'
    },
    {
      year: '2015',
      title: 'Modernizasyon',
      description: 'Modern üretim teknolojileri ve geniş showroom ile hizmet kalitemizi artırdık.'
    },
    {
      year: '2025',
      title: 'Bugün',
      description: 'Ankara\'nın önde gelen perde ve ev tekstili markası olarak hizmet veriyoruz.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white shadow-sm'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center">
              <img src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/2f42915d313b6b9ad9e1e568a266df73.png" alt="Üçoklar Perde" className="h-16 w-auto" />
            </Link>
            
            <div className="hidden lg:flex items-center space-x-8">
              <Link to="/" className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap">Ana Sayfa</Link>
              <Link to="/urunler" className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap">Ürünler</Link>
              <Link to="/hali" className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap">Halı Satışı</Link>
              <Link to="/ev-tekstili" className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap">Ev Tekstili</Link>
              <Link to="/hakkimizda" className="text-sm font-medium text-amber-600 transition-colors whitespace-nowrap">Hakkımızda</Link>
              <Link to="/iletisim" className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap">İletişim</Link>
            </div>

            <Link to="/iletisim" className="hidden lg:block bg-amber-700 hover:bg-amber-800 text-white px-6 py-2.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">
              Teklif Al
            </Link>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-amber-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-6xl md:text-7xl font-bold text-gray-900 mb-6">Hakkımızda</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              30 yıldır Ankara'da perde, halı ve ev tekstili sektöründe kaliteli hizmet sunuyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
            <div className="w-full h-96 rounded-3xl overflow-hidden">
              <img 
                src="https://public.readdy.ai/ai/img_res/6a7f5f237c85f0d6246de1986e1325b5.jpg" 
                alt="Showroom" 
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div>
              <h2 className="text-5xl font-bold text-gray-900 mb-6">Hikayemiz</h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Üçoklar Perde olarak 1995 yılında Ankara'da kurulduk. 30 yıllık tecrübemizle perde, halı, yatak ve ev tekstili sektöründe öncü konumdayız.
              </p>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Müşteri memnuniyetini ön planda tutarak, kaliteli ürünler ve profesyonel hizmet anlayışıyla binlerce müşteriye hizmet verdik. Plise perde, jaluzi perde, tül perde, fon perde, stor perde ve zebra perde imalatı ile birlikte halı satışı, yatak-baza-başlık, duvar kağıdı ve ev tekstili ürünlerinde geniş bir yelpaze sunuyoruz.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                Uzman ekibimiz, ücretsiz keşif ve ölçüm hizmeti ile size en uygun çözümleri sunmak için hazır. Profesyonel montaj ekibimizle kusursuz kurulum garantisi veriyoruz.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-amber-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-gray-900 mb-4">Değerlerimiz</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              İş yapış şeklimizi belirleyen temel değerlerimiz
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${value.icon} text-3xl text-amber-700`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{value.title}</h3>
                <p className="text-gray-600 leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-gray-900 mb-4">Yolculuğumuz</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              30 yıllık başarı hikayemiz
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-amber-200"></div>
            
            <div className="space-y-12">
              {timeline.map((item, index) => (
                <div key={index} className={`flex items-center ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}>
                  <div className={`w-1/2 ${index % 2 === 0 ? 'pr-12 text-right' : 'pl-12 text-left'}`}>
                    <div className="bg-amber-50 rounded-2xl p-8">
                      <div className="text-3xl font-bold text-amber-700 mb-2">{item.year}</div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-3">{item.title}</h3>
                      <p className="text-gray-600 leading-relaxed">{item.description}</p>
                    </div>
                  </div>
                  <div className="w-8 h-8 bg-amber-600 rounded-full border-4 border-white shadow-lg z-10"></div>
                  <div className="w-1/2"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-amber-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-5xl font-bold text-gray-900 mb-6">Bizimle Çalışın</h2>
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            30 yıllık tecrübemizle size en iyi hizmeti sunmak için hazırız. Hemen iletişime geçin.
          </p>
          <Link to="/iletisim" className="inline-block bg-amber-700 hover:bg-amber-800 text-white px-8 py-4 rounded-full text-lg font-medium transition-all hover:scale-105 whitespace-nowrap cursor-pointer">
            İletişime Geç →
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-teal-700 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <svg className="w-full h-full" viewBox="0 0 1200 400">
            <path d="M0,200 Q300,100 600,200 T1200,200" stroke="currentColor" strokeWidth="1" fill="none"/>
            <path d="M0,220 Q300,120 600,220 T1200,220" stroke="currentColor" strokeWidth="1" fill="none"/>
          </svg>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
            <div className="lg:col-span-2">
              <img src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/2f42915d313b6b9ad9e1e568a266df73.png" alt="Üçoklar Perde" className="h-36 mb-6" />
              <p className="text-teal-100 mb-6 leading-relaxed">
                30 yıllık tecrübemizle evinize zarafet katıyoruz. Kaliteli ürünler ve profesyonel hizmet anlayışıyla yanınızdayız.
              </p>
              <div className="flex gap-4">
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-youtube-fill text-xl"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-linkedin-fill text-xl"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Ürünler</h4>
              <ul className="space-y-3">
                <li><Link to="/urunler/plise-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Plise Perde</Link></li>
                <li><Link to="/urunler/jaluzi-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Jaluzi Perde</Link></li>
                <li><Link to="/urunler/tul-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Tül Perde</Link></li>
                <li><Link to="/urunler/fon-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Fon Perde</Link></li>
                <li><Link to="/urunler/zebra-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Zebra Perde</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Ev Tekstili</h4>
              <ul className="space-y-3">
                <li><Link to="/hali" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Halı Satışı</Link></li>
                <li><Link to="/urunler/yatak-baza" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Yatak & Baza</Link></li>
                <li><Link to="/ev-tekstili" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Duvar Kağıdı</Link></li>
                <li><Link to="/ev-tekstili" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Ev Tekstili</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">İletişim</h4>
              <ul className="space-y-3">
                <li className="text-teal-100 text-sm leading-relaxed">
                  <i className="ri-map-pin-line mr-2"></i>
                  Kemalpaşa, Cumhuriyet Cd. No:52, 06780 Elmadağ/Ankara
                </li>
                <li>
                  <a href="tel:+905336178275" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                    <i className="ri-phone-line mr-2"></i>
                    0533 617 82 75
                  </a>
                </li>
                <li>
                  <a href="mailto:info@ucoklarperde.com" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                    <i className="ri-mail-line mr-2"></i>
                    info@ucoklarperde.com
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-teal-600 pt-8">
            <p className="text-teal-100 text-sm text-center">© 2025 Üçoklar Perde. Tüm hakları saklıdır.</p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Button */}
      <a 
        href="https://wa.me/905336178275" 
        target="_blank" 
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 z-50 w-16 h-16 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-2xl transition-all hover:scale-110 cursor-pointer group"
      >
        <i className="ri-whatsapp-line text-3xl text-white"></i>
        <span className="absolute right-20 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          WhatsApp ile İletişim
        </span>
      </a>
    </div>
  );
}